// Shop by Form "Broadside" accordion. Click/tap unfolds one row and folds the
// others (hover only highlights — hover-open was rejected in review). An open
// row acts as its normal collection link on the next click.
class LettoriaBroadside extends HTMLElement {
  connectedCallback() {
    this.rows = Array.from(this.querySelectorAll('.bsf__row'));
    for (const row of this.rows) {
      row.addEventListener('click', (event) => {
        if (!row.classList.contains('is-open')) {
          event.preventDefault();
          this.open(row);
        }
      });
    }
  }

  open(target) {
    for (const row of this.rows) {
      const isOpen = row === target;
      row.classList.toggle('is-open', isOpen);
      row.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  }
}

if (!customElements.get('lettoria-broadside')) {
  customElements.define('lettoria-broadside', LettoriaBroadside);
}
